export const isFalsy = (value: unknown): boolean => {
  if (typeof value === 'string') {
    return value.trim() === '';
  }

  return Boolean(value);
};

export const getEmptyFields = <T extends Object>(data: T) => Object.keys(data).filter((key) => isFalsy(data[key]));
